<div class="container">
    <div class="row">
        <div class="col-24">
            <h1>Individual Enrollment</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-24">

        </div>
    </div>

    <div class="reference-list row">
        <div class="reference-list">

            <div class="list-box">
               
                <p>
                    In 2025, we're offering SilverScript Choice PDP as our only PDP product in all 50 states and Washington, D.C.  2025 SilverScript Choice PDP will be <strong>non-commissionable</strong>. We will continue to pay renewal commissions on all existing commissionable SilverScript PDP business.
</p>

                <p>
                    Enrollment capabilities have been disabled on the portal for 2025 policies. Individual enrollment is available for the 2025 plan year through Think Agent, our virtual sales office application.
                </p>

                <p>
                    Visit
                    <a target="_blank" href="https://www.aetna.com/producer_public/login.fcc?TYPE=33554433&REALMOID=06-aab84995-cc4b-11d5-8cb8-0008c7df6a81&GUID=&SMAUTHREASON=0&METHOD=GET&SMAGENTNAME=-SM-Vkd3CSHVbiUiKN6bT8tPJ8bygxNiAjxDs3%2fNbI5peuL6%2bYSVoJomN51cID11EtZC&TARGET=-SM-https%3a%2f%2fwww%2eaetna%2ecom%2fproducer%2fLogin%2edo">Producer World</a>
                    to learn more about Think Agent including how to request access. Additional questions? Contact us at (866) 714-9301 or at <a href="mailto:brokersupport@aetna.com">brokersupport&#64;aetna.com</a>.
                </p>
            </div>

        </div>
    </div>
</div>














